import { t } from '../../common/i18n';

export const reissunetti2GtContent = (
  <>
    <h5>Elisa Reissunetti</h5>
    <p>
      {t.IU66(
        'Elisa Reissunetti 2 GB activates automatically when you arrive in the destination country. Reissunetti enables fast and affordable data transfer with a mobile device or a laptop in countries outside of the EU and EEA. The service has no monthly fee. Instead, it’s charged based on usage: €26.90 / 14 days.'
      )}
    </p>
  </>
);

export const reissunetti1GtContent = (
  <>
    <h5>Elisa Reissunetti</h5>
    <p>
      {t.IVLR(
        'Elisa Reissunetti 1-1.5 GB activates automatically when you arrive in the destination country. Reissunetti enables fast and affordable data transfer with a mobile device or a laptop in countries outside of the EU and EEA. The service has no monthly fee. Instead, it’s charged based on usage: €21.90 / 14 days.'
      )}
    </p>
  </>
);

export const reissaajaContent = (
  <>
    <h5>Reissaaja</h5>
    <p>
      {t.VTE2(
        'Elisa Reissaaja 500 Mt activates automatically when you arrive in the destination country. Reissaaja enables fast and affordable data transfer with a mobile device or a laptop in countries outside of the EU and EEA. The service has no monthly fee. Instead, it’s charged based on usage: €10.90 / 1 day.'
      )}
    </p>
  </>
);

export const matkapuhelinvastaajaContent = (
  <>
    <h5>Elisa Matkapuhelinvastaaja</h5>
    <p>
      {t.UIVY(
        'With Elisa Matkapuhelinvastaaja, you get a package that includes an out-of-office responder, notifications of missed calls, and mobile voicemail.)'
      )}
    </p>
  </>
);

export const mobiiliturvaContent = (
  <>
    <h5>{t.EH0U('Elisa Mobiiliturva for companies')}</h5>
    <p>
      {t.SG3Q(
        'Elisa Mobiiliturva for companies is a new security service for mobile subscriptions. The service identifies malicious websites, securing the use of your subscription.'
      )}
    </p>
  </>
);

export const itsenainen5GVerkkoContent = (
  <>
    <h5>{t.ELB0('Works over our standalone 5G+ network')}</h5>
    <p>
      {t.ZZ8N(
        '5G subscriptions always use the best and quickest available connection. In areas without 5G coverage, they switch to 4G network instead. Using a 5G+ subscription can cut delay times by half. The new 5G+ technology also saves your phone’s battery, which makes it a more energy-efficient option.)'
      )}
    </p>
  </>
);
